import React,{ useState, useEffect } from 'react'
import { Paper, Box, Button, Typography} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Calender from './Components/Calender/index';
import Loading from './Loading';
import AppointmentDetail from './Components/AppointmentDetail';
import TimerView from './Components/TimerView';
import FormView from './Components/FormView';
import Confirmed from './Components/Confirmed';
import axios from 'axios';
import moment from 'moment';
import './style.scss';
import StateSelectDialog from './Components/StateSelectDialog';
import endpoint_url from './utils/conf';

const style = {
    rightPanel: {
        display:"flex", justifyContent:"center", alignItem:"center", p:5, width:'100%'
    }
}

const HISTORY_CONST = {
    action: "Landed on Appointment Page",
    value: null,
    rfc: null
}

export default function Containers() {
    const hasWindow = typeof window !== 'undefined';
    const [history, setHistory] = useState({...HISTORY_CONST});

    const [step, setStep] = useState(0)
    const [loading, setLoading] = useState(false)
    const [availableDates, setAvailableDates] = useState(null)
    const [meetingId, setMeetingId] = useState(null)

    const [selectedState, setSelectedState] = useState(null)

    const [phone, setPhone] = useState(null)
    const [timeSelected, setTimeSelect] = useState(null)
    const [dateSelected,setDateSelect] = useState(null);
    const [timezoneSelected,setTimezoneSelected] = useState(null);
    
    const [isDesktop, setIsDesktop] = useState(getWindowDimensions().width > 1100);
    const [isTablet,setIsTablet] = useState(getWindowDimensions().width >= 600 && getWindowDimensions().width <= 1100);
    const [isMobile,setIsMobile] = useState(getWindowDimensions().width < 600);
    
    useEffect(()=>{
        setTimeSelect(null)
    },[dateSelected])

    useEffect(()=>{
        if (dateSelected && timeSelected && timezoneSelected) {
            const date = new Date(dateSelected);
            const formattedDate = `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}-${date.getFullYear()}`;

            setHistory({
                ...history,
                action: "Selected datetime and timezone",
                value: `${formattedDate} ${timeSelected} ${timezoneSelected}`
            });
        }
    }, [dateSelected, timeSelected, timezoneSelected])

    const handleHistorySave = async () => {
        const queryParams = new URLSearchParams(window.location.search);
        const rfc = queryParams.get("rfc") ?? localStorage.getItem("rfc");
        queryParams.get("rfc") && localStorage.setItem("rfc", rfc);

        if (rfc) {
            await axios({
                url: endpoint_url+"/store-history",
                method:"POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                data: new URLSearchParams({
                    ...history,
                    rfc: rfc,
                })
            }).then((response)=>{
    
            }).catch((error)=>{
    
            });
        }
    }

    useEffect(()=>{
        handleHistorySave();
    }, []);

    useEffect(() => {
        if (hasWindow) {
            function handleResize() {
                setIsDesktop(getWindowDimensions().width > 1100);
                setIsTablet(getWindowDimensions().width >= 600 && getWindowDimensions().width <= 1100);
                setIsMobile(getWindowDimensions().width < 600);
            }
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }
    }, [hasWindow]);

    function getWindowDimensions() {
        const width = hasWindow ? window.innerWidth : null;
        const height = hasWindow ? window.innerHeight : null;
        return {
            width,
            height,
        };
    }

    useEffect(async () => {
        if(selectedState){
            setLoading(true)
            await getDates();
            await getTimeZone()
            setLoading(false)
        }
    }, [selectedState]);
    
    const getDates = async () => {
        let url = endpoint_url+"/get-date?state="+selectedState;
        const queryParams = new URLSearchParams(window.location.search);
        const rfc = queryParams.get("rfc") ?? localStorage.getItem("rfc");
        if (rfc) {
            url += "&rfc="+rfc;
        }
        await axios({
          url:url,
          method:"GET",
          headers:{
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
        }).then((response)=>{
            let payload = response.data.payload;
            //check if 3600000 key is present
            if(!payload.data.dates[3600000]){
                payload.data.dates[3600000] = {};
            } else if(payload.data.dates[3600000].length === 0){
                payload.data.dates[3600000] = {};
            }
            setAvailableDates(payload.data.dates[3600000])
            setMeetingId(payload.data.hubspot_meeting_link_id)
        }).catch((error)=>{
            setAvailableDates({})
        });
    }
    
    const getTimeZone = async () => {
        await axios({
          url:endpoint_url+"/get-timezone",
          method:"GET",
          headers:{
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
        }).then((response)=>{
            let payload = response.data.payload;
            setTimezoneSelected(payload[selectedState])
        }).catch((error)=>{
        });
    }

    return (
        <>
            <Paper sx={
                isDesktop ? 
                { 
                    width: dateSelected === null ? "60%" : "65%", 
                    display:"flex", justifyContent:"start", alignItem:"center", 
                    my:5, mx:'auto',
                    border: '1px solid #d3d3d3',
                    backgroundColor:"#f0f0f0",
                    position:"relative"
                }
                : { width:"90%", alignItem:"center", mt:5, mx:'auto', backgroundColor:"#f0f0f0", position:"relative"}
            }>
                {
                    !isMobile && <img style={{opacity:0.01}} src="images/logo.png" alt="logo" className='fade_logo'/>
                }
                <Loading isLoading={loading}/> 
                {
                    step === 3 
                    ? <Confirmed time={timeSelected} date={dateSelected} timezone={timezoneSelected} phone={phone} />
                    : <>
                        <Box sx={{px:isMobile ? 0 : 5, width: isMobile || isTablet ? '100%' : '60%'}}>
                            <AppointmentDetail 
                                step={step} 
                                isDesktop={isDesktop}
                                isTablet={isTablet}
                                isMobile={isMobile}
                                setStep={setStep}
                                dateSelected={dateSelected}
                                timezoneSelected={timezoneSelected}
                                timeSelected={timeSelected}
                            />
                        </Box>
                        
                        {/* Mobile View */}
                        <Box 
                            sx={ 
                                isDesktop 
                                ? { ...style.rightPanel, borderLeft: '0.1px solid #cdcdcd' } 
                                : { ...style.rightPanel, borderTop: '0.1px solid #cdcdcd' } 
                            }>
                            {
                                step === 1
                                ? <>
                                    {
                                        (isDesktop || isTablet || (isMobile && dateSelected === null)) && <Box>
                                            {
                                                (availableDates != null && Object.keys(availableDates).length > 0) ? <Calender 
                                                    dateSelected={dateSelected}
                                                    setDateSelect={setDateSelect}
                                                    availableDates={availableDates} 
                                                /> :
                                                <div className='text-center'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" color='#d3d3d3' width={'100px'} fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                                                    </svg>
                                                    <h4>Opps! No dates available.</h4>
                                                    <p>Please retry on other states</p>
                                                </div>
                                            }
                                        </Box>
                                    }
                                    {/* Todo: If date selected then show the timer */}
                                    {
                                        dateSelected && 
                                        <Box width={'100%'}>
                                            { isMobile &&
                                                <Button fullWidth variant="contained" color={"success"} sx={{mb:1}} onClick={()=>{setDateSelect(null)}}>
                                                    <ArrowBackIcon /> &nbsp; Back
                                                </Button>
                                            }
                                            {
                                                !loading && <TimerView 
                                                    timeSelected={timeSelected}
                                                    setTimeSelect={setTimeSelect}
                                                    setStep={setStep}
                                                    handleHistorySave={handleHistorySave}
                                                    availableTime={availableDates[moment(dateSelected).format('YYYY-MM-DD')]}
                                                />
                                            }
                                        </Box>
                                    }
                                </> : step === 2 ? <FormView 
                                        time={timeSelected}
                                        setPhone={setPhone}
                                        date={dateSelected}
                                        timezone={timezoneSelected}
                                        onSubmit={()=>{}}
                                        setStep={setStep}
                                        endpoint_url={endpoint_url}
                                        selectedState={selectedState}
                                        isMobile ={isMobile}
                                        isTablet = {isTablet}
                                        handleHistorySave={handleHistorySave}
                                        setHistory={setHistory}
                                        meetingId={meetingId}
                                /> : <>
                                    <StateSelectDialog
                                        setSelectedState={setSelectedState}
                                        setStep={setStep}
                                    />
                                    <div>
                                        State not selected yet!
                                    </div>
                                </>
                            }
                        </Box>
                    </>
                }
            </Paper>
            <Box sx={{display:isMobile ? "": "flex", textAlign:"center", justifyContent:'center', alignItems:'center', gap:0.5, mb:3}}>
                <Box sx={{width: isMobile ? "100%" : "70%", px:"10px"}}>
                    <small>
                        <b>
                            Benefit Specialists, LLC is not affiliated with, endorsed or sponsored by any federal agency. We are a marketing company only and we are not a financial advisor, broker dealer, investment advisory firm, insurance underwriter/carrier, insurance agency or a Insurance Agents. If you set up an appointment, the person you will be speaking with is not employed by us or by any federal agency. Further, by providing your contact information and setting up an appointment, you agree to our terms of service at <a href="/terms-of-use">Terms of use</a>.
                        </b>
                    </small>
                </Box>
            </Box>
        </>
    )
}


